import { Component, OnInit, ViewChild } from '@angular/core'
import { FormSearchComponent } from '../../../shared/components/form-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { ClientEditComponent } from '../../../features/customer/client-edit/client-edit.component'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { MatPaginator } from '@angular/material/paginator'
import { FormClientSearchComponent } from '../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../shared/utils/utils'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import { ModalDeleteClientComponent } from '../../../features/customer/modal-delete-client/modal-delete-client.component'
import { ClientConvertSubClientComponent } from '../../../features/customer/client-convert-subclient/client-convert-subclient.component'
import { UserManagementService } from '../../../core/services/user-management/user-management.service'
import { MatFormField, MatLabel, MatSuffix} from '@angular/material/input'
import { MatOption, MatSelect, MatSelectTrigger} from '@angular/material/select'
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service';
import {MatIcon} from '@angular/material/icon';
import {
  EmployeeManagementEditComponent
} from '../../../features/user-management/employee-management/employee-management-edit.component';
import {
  DriverManagementWarnComponent
} from '../../../features/user-management/driver-management/driver-management-warn.component'

@Component({
  selector: 'driver-management',
  imports: [
    MatProgressBar,
    TableListComponent,
    FormClientSearchComponent,
    MatPaginatorModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
  ],
  templateUrl: './driver-management.component.html',
  styleUrl: './driver-management.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class DriverManagementComponent implements OnInit {
  constructor(
    private userManagementService: UserManagementService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'cpf',
      key: 'cpf',
      description: 'CPF',
    },
    {
      keyColumn: 'email',
      key: 'email',
      description: 'Email',
    },
    {
      keyColumn: 'tipoMotorista',
      key: 'tipo_motorista',
      description: 'Tipo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, active: true },
      description: 'Ações',
    },
  ]

  listSearch: any = [
    { id: 'nome', description: 'Nome', type: 'string', visible: true },
    {
      id: 'email',
      description: 'Email',
      type: 'string',
      visible: true,
    },
    { id: 'cpf', description: 'Cpf', type: 'string', visible: true },
    { id: 'tipoMotoristaDescricao', description: 'Tipo Motorista', type: 'string', visible: true },
  ]
  orderBySelected: string | null = null
  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  screen: string = 'clientes pessoa juridica'
  sorts: any[] = [
    { id: 'nome:asc', description: 'Nome' },
    { id: 'email:asc', description: 'Email' },
    { id: 'cpf:asc', description: 'Cpf' },
    { id: 'tipo_motorista_id:asc', description: 'Tipo' },
  ]
  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }
  sortChange(event: any) {
    console.log(event)
    this.orderBySelected = event.value
    this.page = 1
    this.uploadList()
  }
  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        active_management: this.checkPermission('editar'),
        sendEmailManagement: this.checkPermission('editar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }
  generatePassword(item: any){
    this.userManagementService.resetPassword(item.usuario_id).subscribe({
      next: () => {
        const dialogRef = this.dialog.open(DriverManagementWarnComponent, {
          enterAnimationDuration: '100ms',
          exitAnimationDuration: '100ms',
          maxWidth: '40vw',
          width: '40vw',
          data: { type: 'driver-management', item: item },
        })
        dialogRef.componentInstance.responseEdit.subscribe((response) => {
          if (response) {
            this.uploadList()
          }
        })
      }, error: error => {
        this.snackbar.errorRequest(error)
      }, complete: () => {
        return
      }
    })
  }
  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  statusItem(event: any) {
    console.log(event)
    const id = event.usuario_id ? event.usuario_id : event.usuarioId ? event.usuarioId : null
    if(id){
      this.userManagementService.changeStatus(id).subscribe({
        next: (response: any) => {
          this.snackbar.success(response?.data?.message ?? 'Sucesso ao alterar status')
        },
        error: error => {
          this.snackbar.errorRequest(error ?? 'Não foi possível alterar status')
        }, complete: () => {
    this.uploadList()
        }
      })
    }
  }
  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] = item.id == element.type ? element.search : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
      this.orderBySelected = null
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.userManagementService
      .listPagedDriver(this.page, this.rows, this.orderBySelected ? this.orderBySelected : '')
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.userManagementService
      .searchPagedDriver(this.page, this.rows, this.orderBySelected ? this.orderBySelected : '', this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.snackbar.errorRequest(err)
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }
  convertClientItem(item: any) {
    const dialogRef = this.dialog.open(ClientConvertSubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '90vw',
      width: '100%',
      maxHeight: '90vh',
      data: { type: 'legal-entity-client', item: item },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList()
      }
    })
  }

  deleteItem(item: any) {
    const dialogRef = this.dialog.open(ModalDeleteClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '40vw',
      width: '100%',
      maxHeight: '90vh',
      data: { item: item, typeClient: 'client' },
    })
    dialogRef.componentInstance.responseDelete.subscribe((response) => {
      if (response.delete) {
        this.uploadList()
      }
    })
  }
}
